<template>
  <div class="cursor case-item w-0 mb-20" :class="index%3 === 0 ? '' : 'ml-19'" @click="toDetail">
    <div class="pic">
      <img src="/images/jian.png" alt="" class="icon" v-if="isJian">
      <el-image :src="Utils.IMG_PREV+planItem.programmePicList[0].pic" fit="cover" class="w-100 h-100"></el-image>
      <div class="mask flex align-center justify-center">
        <div class="btn-40 border-ff radius-round font-16 font-yahei w-124">打开方案</div>
      </div>
    </div>
    <div class="bottom plr-30 ptb-26 w-100">
      <div class="flex align-center justify-space-between mb-6">
        <div class="font-16 color-292a2e font-yahei text-overflow flex-1 w-0 mr-40">{{planItem.name}}</div>
        <div class="color-94 font-12">{{planItem.style}}</div>
      </div>
      <div class="flex align-center mb-8 h-16">
        <div class="tag-16-292a2e" v-for="(item, index) in planItem.programmeTagList" :key="index">{{item.name}}</div>
      </div>
      <div class="flex align-center">
        <span class="color-94 font-12">推荐指数|</span>
        <el-rate v-model="value" disabled :colors="['#c19357', '#c19357', '#c19357']" disabled-void-color="rgba(0,0,0,0.0)"></el-rate>
      </div>
      <div class="flex align-center justify-space-between">
        <span class="font-16 color-c19357 font-arial pt-18">¥{{Utils.toFixedNum(planItem.lowPrice)}}~{{Utils.toFixedNum(planItem.hightPrice)}}</span>
        <img src="/images/jinruxiangqing.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchemeItem',
  computed: {},
  props: ['isJian', 'index', 'planItem'],
  data () {
    return{
      value: 5
    }
  },
  methods: {
    toDetail () {
      let url = this.$router.resolve({name: 'SchemeDetail',query:{id: this.planItem.id + '.html'}})
      window.open(url.href,'_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
  .case-item{
    width: 454px;
    position: relative;
    .icon{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .pic{
      border-radius: 4px;
      overflow: hidden;
      height: 298px;
    }
    .bottom{
      box-shadow: 0px 30px 70px 0px rgba(41, 42, 46, 0.07);
      border-radius: 4px;
      background: #fff;
    }
    .mask{
      background: rgba($color: #c19357, $alpha: 0.85);
      width: 100%;
      height: 298px;
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 4px;
      overflow: hidden;
      z-index: 8;
    }
    &:hover{
      .mask{
        display: flex;
      }
    }
    .w-124{
      width: 124px;
    }
  }
  .h-16{
    height: 16px;
  }
</style>
